import { createSlice } from '@reduxjs/toolkit';
import { globalState } from './state';

export const globalSlice = createSlice({
  name: 'global',
  initialState: globalState,
  reducers: {
    addTotalCart: (state, action) => {
      state.totalCart = action.payload;
    },
    addPengiriman: (state, action) => {
      state.alamatPengiriman = action.payload;
    },
    changeLoading: (state, action) => {
      state.loadingGeneral = action.payload;
    },
    changeDataProfile: (state, action) => {
      state.dataProfile = action.payload;
    },
    changeDataCategory: (state, action) => {
      state.dataCategory = action.payload;
    },
    changeDataBrand: (state, action) => {
      state.brand = action.payload;
    },
    changeDataNotification: (state, action) => {
      state.dataNotification = action.payload;
    },
    changeQbSession: (state, action) => {
      state.qbSession = action.payload;
    },
    changeQbUnread: (state, action) => {
      state.qbUnread = action.payload;
    },
    changeQbNewMessage: (state, action) => {
      state.qbNewMessage = action.payload;
    },
    changeMode: (state, action) => {
      state.mode = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addTotalCart,
  addPengiriman,
  changeLoading,
  changeDataProfile,
  changeDataCategory,
  changeDataBrand,
  changeDataNotification,
  changeQbSession,
  changeQbUnread,
  changeQbNewMessage,
  changeMode,
} = globalSlice.actions;

export default globalSlice.reducer;
